import type { RoleId } from '@vlabs/api/artemy/model';
import { useParams } from 'react-router-dom';

export function useRoleIdFromLocation(): RoleId {
  const { roleId } = useParams<{ roleId: RoleId }>();

  if (!roleId) {
    throw new Error('RoleId is missing or invalid');
  }

  return roleId;
}
